import { getLeadData } from "../../mobile/views/_text_input_modal_helper";
import {CommonPlatformUtilities} from "../utils";
import { generateLeadIdForRCM } from "mortgage/jornaya_lead_id";

/**
 * Schedule Tour Module
 *
 * Implemented in both the quick-view and LDP.
 * Exported as default in section_schedule_tour.
 * LDP Template: _schedule_tour.html.erb
 * QV Template: schedule-tour.jst.ejs
 *
 * @module ldp/common_platform/views/schedule_tour
 */
export const ScheduleTourModule = (function (LDP) {

  /**
   * Contact Agent CSS Class
   * @type {string}
   */
  const contactAgentBtn = '.contact-agent-btn';

  /**
   * Day Names
   * @type {string[]}
   */
  const DAY_NAMES = ["sun", "mon", "tue", "wed", "thur", "fri", "sat"];

  /**
   * Element Queries
   * @type {jQuery|HTMLElement}
   */
  const $stWrapper = $('.st-wrapper'),
        $stCarouselWrapper = $('.st-owl-carousel'),
        $stCarouselItem = $('.st-owl-carousel .item'),
        $stDurationItem = $('.st-duration-picker .time-card'),
        $stView1 = $('.st-view-1'),
        $stView2 = $('.st-view-2'),
        $stView3 = $('.st-view-3'),
        $stView2Tabs = $('.st-view-2-tabs p'),
        $stSelectButton = $('.st-select-btn'),
        $stScheduleButton = $('.st-schedule-btn'),
        $stCancelButton = $('.st-cancel-btn'),
        $stTimePicker = $('.st-duration-picker'),
        $st2CallMeBtn = $('.cta-call-btn'),
        $st2TextMeBtn = $('.cta-text-btn'),
        $st2ContactInput = $('.st-contact-input'),
        $stFooter = $('.st-footer'),
        $st3ContactAgent = $(contactAgentBtn),
        $stCloseBtn = $('.st-close-btn'),
        $stViewListingBtn = $('.view-listing-btn'),
        $stGoBackBtn = $('.go-back-btn'),
        $stThankYouText = $('.st-thank-you-text'),
        $stToday = $('.st-today'),
        $stAddress = $('#st-address'),
        $qvAside = $('#qv-aside'),
        $stRequestTourBtn = $('.request-tour-btn'),
        $stMobileError = $('.st-mobile-error');

  /**
   * Cookie Name
   * @type {string}
   */
  const stCookie = 'st-mobile-number';

  /**
   * Cookie Value
   * @type {number}
   */
  const stCookieValue = CommonPlatformUtilities.getCookie(stCookie);

  /**
   * Schedule tour post request object
   * @type {{}}
   * @private {Object}
   */
  let requestObj = {};

  /**
   * Schedule Tour State
   * @type {{
   *  body: string,
   *  call: boolean,
   *  date: string,
   *  mobile: boolean,
   *  timeSelected: boolean,
   *  dateSelected: boolean,
   *  text: boolean,
   *  time: string,
   *  lazyLoad: boolean,
   *  tablet: boolean
   * }}
   */
  let state = {
    text: true,
    call: false,
    dateSelected: false,
    timeSelected: false,
    date: '',
    time: '',
    address: $stAddress.data('value'),
    body: '',
    lazyLoad: true,
    mobile: $(window).width() <= 414,
    tablet: $(window).width() <= 768 && $(window).width() > 414
  };

  /**
   * Carousel Items
   * @type {number}
   */
  const carouselItems = state.tablet ? 4 : 3;

  /**
   * Owl carousel options
   * @type {{
   *  nav: boolean,
   *  margin: number,
   *  autoHeight: boolean,
   *  slideBy: number,
   *  navText: string[],
   *  items: number,
   * }}
   */
  const options = {
    nav: true,
    items: carouselItems,
    slideBy: carouselItems,
    margin: state.mobile ? -15 : (state.tablet ? 0 : 6),
    autoHeight: true,
    navText: ["<span class='st-chevron'>&lsaquo;</span>", "<span class='st-chevron'>&rsaquo;</span>"]
  };

  /**
   * Go to view 2
   * @private
   * @returns {void}
   */
  function goBackToView1() {
    $stGoBackBtn.on('click', function () {
      $stView1.fadeIn(200);
      $stView2.hide();
      $stCancelButton.css('display', 'none');
    });
  }

  /**
   * RDC Tracking
   * @private
   * @returns {void}
   */
  function scheduleTourTracking(property) {
    const {propertyStatus, listing} = property,
      {leadDelivery} = listing,
      {text} = state,
      event = text ? 'forSaleCobrokeTextLead' : 'forSaleCobrokePhoneLead',
      linkName = `web:leads:${text ? 'text' : 'phone'}:${propertyStatus}:${leadDelivery}`,
      leadPlacement = `for_sale:${property.pageType === 'ldp-quickview' ? 'ldp_quickview' : 'ldp'}:${MOVE_DATA.isPhone ? 'sticky_footer':'primary_top'}:contact_agent_schedule_tour`;

    if (text) {
      const textLeads = linkName;
      RdcTracking.trackEvent(event, {
        textLeads,
        linkName,
        leadPlacement
      });
    } else {
      const phoneLeads = linkName;
      const rentalDataSource = 'unknown';

      RdcTracking.trackEvent(event, {
        phoneLeads,
        linkName,
        leadPlacement,
        rentalDataSource
      });
    }
  }

  /**
   * On mobile number post success - route to thank you page
   * @private
   * @returns {void}
   */
  function requestSuccess() {
    $stView2.hide();
    $stView3.fadeIn(2000);
    $stViewListingBtn.show();
    $stFooter.show();

    if (!state.mobile && !state.tablet) {
      resetState();
    } else {
      resetMobileState(true);
    }
  }

  /**
   * Post request submit handler
   * @param property
   * @private
   * @returns {void}
   */
  function requestSubmitHandler(property) {

    scheduleTourTracking(property);

    const options = {
      isScheduleTour: true,
      mobileNumber: requestObj.mobileNumber,
      stDate: state.date,
      stTime: state.time,
      isStCall: state.call,
    };

    document.cookie = `${stCookie}=${requestObj.mobileNumber}`;
    $.ajax({
      data: getLeadData("", property, options),
      url: "/leads",
      type: 'POST',
      success: requestSuccess(),
      error: err => console.log(err)
    });
  }

  /**
   * Request tour button event listener.
   * Route to view 3, thank you page.
   * @private
   * @returns {void}
   */
  function requestTourListener() {
    const property = MOVE_DATA.adobeDTM || {};
    $stRequestTourBtn.off('click').on('click', function (e) {
      state.body = `I'm interested in scheduling a tour of ${state.address} on ${state.date} ${state.time}`;
      e.preventDefault();

      if (CommonPlatformUtilities.phoneNumberValid(requestObj.mobileNumber)) {
        requestSubmitHandler(property);
        $stMobileError.hide();
      } else {
        $stMobileError.show();
        $stMobileError.text('Please enter a valid phone number');
      }
    });
  }

  /**
   * Select tabs
   * @private
   * @returns {void}
   */
  function selectCTATabs() {
    $stView2Tabs.on('click', function () {
      $stView2Tabs.removeClass('cta-active');
      $(this).addClass('cta-active');
    });
  }

  /**
   * Call Me tab event handler.
   * Set the request-tour-btn element with an href of tel
   * @private
   * @returns {void}
   */
  function callMeListener() {
    $st2CallMeBtn.on('click', () => {
      state.call = true;
      state.text = false;
      $stThankYouText.text('call');
    });
    CommonPlatformUtilities.formatPhone();
  }

  /**
   * Text Me event handler.
   * Set the request-tour-btn element with an href of sms
   * @private
   * @returns {void}
   */
  function textMeListener() {
    $st2TextMeBtn.on('click', () => {
      state.text = true;
      state.call = false;
      $stThankYouText.text('text');
    });
    CommonPlatformUtilities.formatPhone();
  }

  /**
   * Input change event handler
   * @private
   * @returns {void}
   */
  function contactInputListener() {
    $st2ContactInput.on('keyup', (val) => {
      requestObj.mobileNumber = val.target.value;
    });
  }

  /**
   * Route to view 2
   */
  function routeToView2() {
    $stView1.hide();
    $stView2.fadeIn(200);
  }

  /**
   * Screen 1a. call to action event
   * @private
   * @returns {void}
   */
  function scheduleBtnListener() {
    $stScheduleButton.on('click', function () {
      if (!MOVE_DATA.leadid_token) generateLeadIdForRCM();
      if (!state.mobile && !state.tablet && state.dateSelected) {
        $stFooter.hide();
        $stTimePicker.show();
        $stCancelButton.css('display', 'block');
        $stScheduleButton.hide();
        $stSelectButton.css('display', 'block');
        state.dateSelected = true;
      } else {
        routeToView2();
      }
    });
  }

  /**
   * Screen 1b. call to action event
   * @private
   * @returns {void}
   */
  function selectBtnListener() {
    $stSelectButton.on('click', () => {
        routeToView2();
    });
  }

  /**
   * Cancel button event listener
   * @private
   * @returns {void}
   */
  function cancelButtonListener() {
    $stCancelButton.on('click', function () {
      resetState();
      selectDefaultDate();
      selectDefaultTime();
    });
  }

  /**
   * Reset state
   * @private
   * @returns {void}
   */
  function resetState() {
    $stFooter.show();
    $stTimePicker.hide();
    $stScheduleButton.show();
    $stSelectButton.hide();
    $stCancelButton.hide();
    $stViewListingBtn.hide();
    if(!LDP) {
      $stCarouselItem.removeClass('st-active');
      $stDurationItem.removeClass('st-active');
    }
  }

  /**
   * Reset mobile state
   * @private
   * @returns {void}
   */
  function resetMobileState(flag) {
    $stFooter.hide();
    $stScheduleButton.show();
    $stSelectButton.hide();
    $stCancelButton.hide();
    $stCarouselItem.removeClass('st-active');
    $stDurationItem.removeClass('st-active');
    if(LDP) {
      selectDefaultDate();
      selectDefaultTime();
    }
    if(!flag) {
      $stView3.hide();
    }
  }

  /**
   * Initialize the mobile view.
   * Add and remove appropriate classes as needed.
   * @private
   * @returns {void}
   */
  function mobileViewInit() {
    if (state.mobile) {
      $qvAside.remove();
      $stFooter.hide();
      $stScheduleButton.val('Select');
      $stTimePicker.show();
      $stTimePicker.removeClass('time-card-border');
      $stWrapper.addClass('st-mobile');
      $stCloseBtn.show();
      $st3ContactAgent.hide();
      addScheduleTourCtaTracking();
    }
  }

  /**
   * Add Schedule Tour cta modalImpression tracking
   * @private
   * @returns {void}
   */
  function addScheduleTourCtaTracking(){
    const modalName = 'for_sale:schedule_tour';
    const modalTrigger = `for_sale:${MOVE_DATA.quickview ? 'ldp_quickview':'ldp'}:sticky_footer:contact_agent_schedule_tour`;
    $('.ot-schedule-tour').on('click', function(){
      RdcTracking.trackEvent('modalImpression', { modalName, modalTrigger })
    })
  }

  /**
   * Close mobile modal
   * @private
   * @returns {void}
   */
  function closeModal() {
    resetMobileState();
    $stView2.hide();
    $stView3.hide();
    $stView1.show();
  }

  function closeMobileSTModal() {
    $stCloseBtn.on('click', function() {
      closeModal();
    });
  }

  function viewListingButton() {
    $stViewListingBtn.on('click', function() {
      closeModal();
    });
  }

  /**
   * Select date event listener
   * @private
   * @returns {void}
   */
  function selectDateListener() {
    $stCarouselItem.on('click', function () {
      $stCarouselItem.removeClass('st-active');
      $(this).addClass('st-active');

      state.date = $(this).data('value');
      state.dateSelected = true;
    });
  }

  /**
   * Select default date
   * @private
   * @returns {void}
   */
  function selectDefaultDate() {
    const item = $stCarouselItem.eq(1);
    item.addClass('st-active');

    state.date = item.data('value');
    state.dateSelected = true;
  }

  /**
   * Select default time
   * @private
   * @returns {void}
   */
  function selectDefaultTime() {
    const item = $stDurationItem.eq(0);
    item.addClass('st-active');

    state.time = item.data('value');
    state.timeSelected = true;
  }

  /**
   * Select time event listener
   * @private
   * @returns {void}
   */
  function selectTimeListener() {
    $stDurationItem.on('click', function () {
      $stDurationItem.removeClass('st-active');
      $(this).addClass('st-active');

      state.time = $(this).data('value');
      state.timeSelected = true;
    });
  }

  /**
   * Init functions when component is rendered
   * @private
   * @returns {void}
   */
  function componentDidMount() {
    selectDefaultTime();
    selectDefaultDate();
    if(!state.mobile) {
      $stFooter.show();
    }
    const cookieVal = stCookie ? stCookieValue : '';
    $stCarouselWrapper.owlCarousel(options);
    $stWrapper.show();
    $('.st-disabled').removeClass('st-disabled');
    $st2ContactInput.val(cookieVal);
    requestObj.mobileNumber = cookieVal;
  }


  function setDay() {
    const now = new Date();
    const timeThreshold = 23;
    const currentTime = now.getHours() + 7;
    if(currentTime >  timeThreshold) {
      $stToday.text(DAY_NAMES[(now.getDay() + 1) % 7]);
    }
    else {
      $stToday.text('Today');
    }
  }

  function tabletInit() {
    if (state.tablet) {
      $stScheduleButton.val('Select');
      $stFooter.hide();
      $qvAside.remove();
      $stTimePicker.show();
      $stCarouselWrapper.css('width', '82%');
    }
  }

  /**
   * Init carousel and event listeners.
   * @public
   * @constructor
   * @returns {void}
   */
  function Init() {
    resetState();
    resetMobileState();
    componentDidMount();

    // view-1
    selectDateListener();
    selectTimeListener();
    selectBtnListener();
    scheduleBtnListener();
    cancelButtonListener();
    setDay();

    // view-2
    callMeListener();
    textMeListener();
    contactInputListener();
    requestTourListener();
    selectCTATabs();
    goBackToView1();

    // view-3
    viewListingButton();
    closeMobileSTModal();
    CommonPlatformUtilities.scrollOnClick(contactAgentBtn);

    mobileViewInit();
    tabletInit();
  }

  if (LDP) {
    LDP.STDatePicker = {
      init: new Init()
    };
  } else {
    new Init();
  }

});
/**
 * Set the MOVE LDP Schedule Tour variable
 * @public
 * @returns {void}_schedule
 */
function setGlobalScheduleTourVar() {
  if (MOVE.LDP) {
    MOVE.LDP.STDatePicker = new ScheduleTourModule(MOVE.LDP || {});
  }
}

setGlobalScheduleTourVar();



// WEBPACK FOOTER //
// ./ldp/common_platform/views/_schedule_tour.js